import React from 'react';
import { useTranslation } from 'react-i18next';
import './References.css';
import walter from './images/walter-logo.webp';
import baumuller from './images/baumuller-logo.png';
import magerle from './images/magerle-logo.webp';
import ucb from './images/UCB-logo.webp';
import buhler from './images/buhler-logo.webp';
import edwards from './images/Edwards-logo.png';
import putzmeister from './images/putzmeister-logo.webp';
import starrag from './images/starrag-logo.webp';
import { Reveal, SplitText } from './motion';

const PARTNERS = [
  { name: 'Walter', logo: walter },
  { name: 'Baumüller', logo: baumuller },
  { name: 'Mägerle', logo: magerle },
  { name: 'UCB', logo: ucb },
  { name: 'Bühler', logo: buhler },
  { name: 'Edwards', logo: edwards },
  { name: 'Putzmeister', logo: putzmeister },
  { name: 'Starrag', logo: starrag },
];

const Row = ({ reverse = false }) => (
  <div className={`refs__row ${reverse ? 'refs__row--reverse' : ''}`}>
    {/* Druhá kopie je jen pro plynulou smyčku – čtečky ji přeskočí */}
    {[0, 1].map((copy) => (
      <ul className="refs__set" key={copy} aria-hidden={copy === 1 || reverse}>
        {PARTNERS.map((p) => (
          <li className="refs__logo" key={p.name}>
            <img src={p.logo} alt={copy === 0 && !reverse ? p.name : ''} loading="lazy" />
          </li>
        ))}
      </ul>
    ))}
  </div>
);

const References = () => {
  const { t } = useTranslation();
  return (
    <section id="references" className="section section--light refs">
      <div className="container">
        <div className="section-head section-head--split">
          <div className="section-head">
            <SplitText text={t('references.title')} className="section-head__title" />
          </div>
          <Reveal as="p" className="section-head__desc" delay={0.15}>
            {t('references.desc')}
          </Reveal>
        </div>
      </div>
      <Reveal className="refs__marquee" y={20}>
        <Row />
        <Row reverse />
      </Reveal>
    </section>
  );
};

export default References;
